export default __webpack_public_path__ + "zap-arrow.svg?23925763170116fd6cf75bbb8199b4a8";